/* eslint-disable max-len */
import React, { useState, useEffect } from 'react'
import {
  getAmendmentLink,
  getCancellationLink,
  fireClevertapEvent,
  getQueryParams
} from 'AccountsUtils'
import DesktopModal from '../DesktopModal'
import { getMappedValue } from '../../utils/arabicUtils'

const sectorReducer = (condition, sector) => {
  const { airline, departureCity, arrivalCity } = sector
  let returnString = ''
  if (condition) {
    returnString = `(${airline}) ${departureCity} ${getMappedValue(
      'to'
    )} ${arrivalCity}`
  }
  return returnString
}
const openTicketSectorReducer = sector => {
  const { airline, departureCity, arrivalCity, paxNames, openTicket } = sector
  let paxDetail = null
  if (openTicket) {
    const paxNamesArr =
      paxNames &&
      paxNames.map(data => {
        return `${data.firstName}`
      })
    if (paxNamesArr.length > 1) {
      paxNamesArr[paxNamesArr.length - 1] = `${getMappedValue('and')} ${
        paxNamesArr[paxNamesArr.length - 1]
      }`
    }
    paxDetail = paxNamesArr
      .join(', ')
      .replace(', and', ` ${getMappedValue('and')}`)
  }
  let returnString = ''
  returnString = `(${airline}) ${departureCity} ${getMappedValue(
    'to'
  )} ${arrivalCity} ${
    openTicket ? `${getMappedValue('flight for')} ${paxDetail}` : ''
  },`
  return returnString
}
const linkMsgReducer = (link, msg) => {
  let returnStr = null
  if (link) {
    returnStr = msg.replace('$$replace$$', link)
  }
  return returnStr
}

const airlineMsgMap = {
  SG: getMappedValue(
    'Spice Jet has auto Cancelled all bookings and have converted them into Credit Shell/Voucher (of the entire booking amount) and you will need to contact Spice Jet call center post 1st April 2020 until 21st Feb 2021 to redeem the credit towards this booking for the new booking of your choice. (Fare difference if any will have to be paid at the time of making a new booking)'
  ),
  indigo: getMappedValue(
    'To rebook a new ticket with credit shell. 1. Please click on "Contact Us" 2. Click rebook & an cleartripper will get back to you.'
  ),
  G8: getMappedValue(
    'Go Air is not allowing any refunds against cancellations at this point and you can call Go Air Call Center up to 30th September 2020 and make a new booking using the same amount of this ticket (Fare difference if any will have to be paid at the time of making a new booking)'
  )
}
const linkMapTxt = {
  openTicket: {
    flag: false,
    travelData: '',
    action: ['cancel'],
    linkTxt: [getMappedValue('open ticket/credit shell')],
    linkIndex: null,
    mainTxt: getMappedValue(
      "You can convert your $$replace$$ trip to an open ticket/credit shell. You won't get any refund now, but you can come back and amend this booking to a different date later."
    )
  },
  amendAndCancel: {
    flag: false,
    travelData: '',
    linkIndex: 0,
    linkTxt: [getMappedValue('change flight'), getMappedValue('cancel flight')],
    action: ['amend', 'cancel'],
    mainTxt: getMappedValue(
      'Your $$replace$$ flight is/are eligible for a free cancellation/flight change due to coronavirus. Fare difference applicable for flight changes.'
    )
  },
  onlyCancel: {
    flag: false,
    travelData: '',
    linkIndex: 0,
    linkTxt: [getMappedValue('cancel flight')],
    action: ['cancel'],
    mainTxt: getMappedValue(
      'Your $$replace$$ flight is/are eligible for a free cancellation due to coronavirus.'
    )
  },
  onlyAmend: {
    flag: false,
    travelData: '',
    linkIndex: 0,
    linkTxt: [getMappedValue('change flight')],
    action: ['amend'],
    mainTxt: getMappedValue(
      'Your $$replace$$ flight is/are eligible for flight change due to coronavirus. Fare difference applicable for flight changes.'
    )
  }
}

const NoticeBanner = ({
  tripDetails,
  tripId,
  newAmendFlow,
  status,
  isPWA = true,
  disableLinkFlag = false
}) => {
  const [bannerMsg, setBannerMsg] = useState([])
  const [linkMap, setLinkMap] = useState({ ...linkMapTxt })
  const [modalData, setModalData] = useState([])
  const [showModalFlag, setShowModalFlag] = useState(false)
  const [linksFlag, setLinksFlag] = useState(false)
  const params = getQueryParams()

  useEffect(() => {
    if (
      status &&
      ['UPCOMING', 'CONFIRMED', 'EXPIRED', 'COMPLETED'].indexOf(
        status.toUpperCase()
      ) > -1
    ) {
      const { segmentRefunds, flightDetails, openTicketSegments } =
        tripDetails || {}
      let msgArr = []
      let newMsg = ''
      if (
        flightDetails &&
        flightDetails.length > 0 &&
        segmentRefunds &&
        segmentRefunds.openTicket
      ) {
        if (flightDetails && flightDetails.length > 1) {
          newMsg = getMappedValue(
            'All or few sectors in your trip are eligible for credit shell from the airline due to coronavirus pandemic.'
          )
        } else {
          const flight = flightDetails ? flightDetails[0] : null
          newMsg =
            flight && flight.segmentDetails && flight.segmentDetails.length > 1 ?
              getMappedValue(
                'All or few sectors in your trip are eligible for credit shell from the airline due to coronavirus pandemic.'
              ) :
              getMappedValue(
                'Your trip is eligible for credit shell from the airline due to coronavirus pandemic.'
              )
        }
        msgArr = msgArr.concat([{ msg: newMsg, linkIndex: 1 }])
      }
      if (
        flightDetails &&
        flightDetails.length > 0 &&
        openTicketSegments &&
        openTicketSegments.length > 0
      ) {
        const openTicketSegmentsDetail = openTicketSegments.filter(
          idx => idx.openTicket === true
        )
        if (openTicketSegmentsDetail.length > 0) {
          const replacerText = []
          newMsg = getMappedValue(
            'Your $$replace$$ has been converted into an open ticket/credit shell. As per the Airline policy, there is no refund applicable for this booking and they have offered to adjust the entire amount in your next booking for the same passenger. To rebook your open ticket or utilise credit shell, Kindly click on "contact us" and select the "Rebook open ticket or utilise credit shell" option.'
          )
          for (const sector of openTicketSegmentsDetail) {
            replacerText.push(openTicketSectorReducer(sector))
          }
          msgArr = msgArr.concat([
            { msg: linkMsgReducer(replacerText.join(' '), newMsg) }
          ])
        }
      }
      if (segmentRefunds && segmentRefunds.length) {
        // eslint-disable-next-line no-unused-vars
        let isNonEligible = true
        let consolidatedMsg = []
        const linkMapClone = { ...linkMap }
        for (const sector of segmentRefunds) {
          const { openTicket, fullRefundCancel, fullRefundAmend } = sector
          linkMapClone.amendAndCancel.travelData += ` ${sectorReducer(
            fullRefundCancel && fullRefundAmend,
            sector
          )}`
          linkMapClone.amendAndCancel.flag =
            linkMapClone.amendAndCancel.flag ||
            (fullRefundCancel && fullRefundAmend)
          linkMapClone.openTicket.travelData += ` ${sectorReducer(
            openTicket,
            sector
          )}`
          linkMapClone.openTicket.flag =
            linkMapClone.openTicket.flag || openTicket
          linkMapClone.onlyCancel.travelData += ` ${sectorReducer(
            fullRefundCancel && !fullRefundAmend,
            sector
          )}`
          linkMapClone.onlyCancel.flag =
            linkMapClone.onlyCancel.flag ||
            (fullRefundCancel && !fullRefundAmend)
          linkMapClone.onlyAmend.travelData += ` ${sectorReducer(
            !fullRefundCancel && fullRefundAmend,
            sector
          )}`
          linkMapClone.onlyAmend.flag =
            linkMapClone.onlyAmend.flag ||
            (!fullRefundCancel && fullRefundAmend)
        }
        Object.keys(linkMapClone).forEach(data => {
          const { travelData, mainTxt, linkIndex, flag } = linkMapClone[data]
          if (travelData) {
            isNonEligible = false
            if (!linksFlag && flag) {
              setLinksFlag(true)
            }
            const msg = linkMsgReducer(travelData, mainTxt)
            consolidatedMsg = flag ?
              consolidatedMsg.concat([{ msg, linkIndex }]) :
              consolidatedMsg
          }
        })
        // commenting as its valid pre covid.
        // if (isNonEligible) {
        // eslint-disable-next-line max-len
        // consolidatedMsg = consolidatedMsg.concat([{ msg: 'NOTE: Cancelling or changing a flight that is currently not eligible for free cancellations or free flight changes will be chargeable, as per standard airline policy' }])
        // }
        msgArr = msgArr.concat(consolidatedMsg)
        setLinkMap({ ...linkMapClone })
      }
      if (msgArr.length > 1) {
        fireClevertapEvent('corona_banner_shown', {
          trip_id: tripDetails.tripId,
          trip_status: tripDetails.bookingStatus
        })
      }
      // msgArr = msgArr.concat([{ msg: 'NOTE: Cancelling or changing a flight that is currently not eligible for free cancellations or free flight changes will be chargeable, as per standard airline policy' }])
      setBannerMsg(msgArr)
    }
  }, [tripDetails])
  const onModalOpen = e => {
    e.preventDefault()
    e.stopPropagation()
    if (
      tripDetails &&
      tripDetails.flightDetails &&
      tripDetails.flightDetails.length > 0
    ) {
      let newModalData = [...modalData]
      tripDetails.flightDetails.forEach(flight => {
        const { segmentDetails } = flight
        segmentDetails.forEach(segment => {
          const { airlineName, contactNumber } = segment
          let { operatingAirline } = segment
          operatingAirline =
            operatingAirline === '6E' ? 'indigo' : operatingAirline
          newModalData = newModalData.filter(
            item => item.code !== operatingAirline
          )
          newModalData = newModalData.concat([
            { code: operatingAirline, airline: airlineName, contactNumber }
          ])
        })
      })
      setModalData(newModalData)
      setShowModalFlag(true)
    }
  }
  const linkArr = [
    <span>
      <a className="c-blue" href="/coronahelp">
        {getMappedValue('Click here')}
      </a>{' '}
      {getMappedValue('to see all airline policies.')}
    </span>,
    <span>
      <a href="#" className="c-blue" onClick={onModalOpen}>
        {getMappedValue('Click here')}
      </a>{' '}
      {getMappedValue(
        'to know how to claim a refund or reschedule your flight(s)'
      )}
    </span>
  ]
  const AirlineTable = () => (
    <table className="bordered-table">
      <tbody>
        {modalData.map(data => (
          <React.Fragment key={`${Math.random()}`}>
            <tr className="bordered-table-row">
              <td className="fs-13 p-2 c-grey-60 fw-700">{data.airline}</td>
              <td className="fs-13 p-2 c-grey-60">
                {airlineMsgMap[data.code] ?
                  airlineMsgMap[data.code] :
                  getMappedValue(
                    `please call the airline at ${data.contactNumber} to refund or reschedule your flight`
                  )}
              </td>
            </tr>
          </React.Fragment>
        ))}
      </tbody>
    </table>
  )
  return (
    <If condition={bannerMsg.length > 0}>
      <div className="new-banner mb-1 pt-1">
        <DesktopModal
          showFlag={showModalFlag}
          onCloseModal={() => setShowModalFlag(false)}
          header={getMappedValue('Airline Info')}
        >
          <AirlineTable />
        </DesktopModal>
        {bannerMsg.map(({ msg, linkIndex }) => (
          <div className="fs-11 px-4 py-2">
            <React.Fragment>
              <p>
                {msg}
                <If condition={linkIndex !== null}>{linkArr[linkIndex]}</If>
              </p>
            </React.Fragment>
          </div>
        ))}
        <If condition={linksFlag}>
          <div className="p-4 flex flex-end">
            {Object.keys(linkMap).map((key, outerIndex) => {
              const { action, linkTxt, flag } = linkMap[key]
              return (
                <If condition={action.length > 0 && !disableLinkFlag && flag}>
                  {action.map((item, index) => (
                    <a
                      key={`icon_${Math.random()}`}
                      className={`c-blue fw-500 ${
                        index > 0 || outerIndex > 0 ? 'ml-2' : ''
                      } tt-uppercase`}
                      href={
                        item === 'amend' ?
                          getAmendmentLink(newAmendFlow, tripId, params) :
                          getCancellationLink(tripId, params)
                      }
                    >
                      {linkTxt[index]}
                    </a>
                  ))}
                </If>
              )
            })}
          </div>
        </If>
      </div>
    </If>
  )
}

export default NoticeBanner
